"use client";

import { useHydrated } from "@utils/hooks";
import analytics from "./analytics";

interface Props {
  eventname: string;
  properties?: Record<string, any>;
}

export default function AnalyticsTrack({ eventname, properties }: Props) {
  const hydrated = useHydrated();

  if (hydrated) {
    analytics.track(eventname, properties);
  }

  return <></>;
}
